export default "__VITE_ASSET__p9y5m47Z__"